import React from 'react'
import PersonIcon from '@material-ui/icons/Person';
import DateRangeIcon from '@material-ui/icons/DateRange';
import PeopleIcon from '@material-ui/icons/People';
import { Link } from 'react-router-dom'
import MenuBookIcon from '@material-ui/icons/MenuBook';



function Section() {
    return (
        <div className='section'>
            <div className="section_bar">
                <div className="section_baritem">
                <div className="top_item">
                    <DateRangeIcon />
                    <h2>Extended Stays</h2></div>
                    <p className="barItem_p">
                    Staying for over 2 weeks? Let us negotiate
                     a discounted long stay hotel rate for you!
                    </p>

                </div>

                <div className="section_baritem">
                    <div className="top_item">
                    <PeopleIcon />
                    <h2>Group Hotel Rates</h2></div>
                    <p className="barItem_p">
                    Need 5+ rooms per night?Lock in 
                    a discounted group rate for your event.</p>
                </div>

                <div className="section_baritem">
                <div className="top_item">
                    <PersonIcon />
                    <h2>Individual Discounts</h2></div>
                    
                    <p className="barItem_p">
                    We offer many exclusive discounts as well as special discounts
                     for AAA members,military/government personnel and senior citizens (AARP).
                    </p>

            </div>
            </div>
            <div className="section_main">

                <div className="section_maintitle">
                    <h2>
                        We Have Group Hotel Rates For Any Type Of Group !
                    </h2>
                    <p>
                        <strong>Save up to 77% </strong>
                     of our group hotel rates and it's completely free.
                    </p>
                </div>
                <div className="section_gallery">
                    <div className="gallery_image">
                        <img src="assets/wedding.webp" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Wedding</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/coperate incentive.jpg" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description"> Coperate Events</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/conference room.webp" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Conference Meetings</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/business meetings.webp" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Business Meetings</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/group tours.jpg" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Group Tours</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/reunions.webp" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Re-Unions</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/sport teams.webp" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Sport Events</div>
                    </div>
                    <div className="gallery_image">
                        <img src="assets/hotel entrance.webp" alt="wedding"  />
                        <div className="section_galleryoverlay"></div>
                        <div className="gallery_description">Travel</div>
                    </div>
                </div>
            </div>
        <div className="section_subsection">
            <div className="top_subsection">
            <div className="first_sub">
               <Link>
                <h2>
                    Premium RFP Deals
                </h2>
                </Link>
            </div>
            <div className="second_sub">
                <p>
                    Find your best fit Conference center venue. <br /> 
                    The industry's lowest online quote from
                    vendors.
                </p>
            </div></div>
                <div className="bottom_subsection">
                    <div className="image_cover">
                        <div className="image_coveroverlay"></div>
                        <div className="image_coverContent">
                            <div className="heading">
                                <h2>
                                    Confirmed lowest group rates online
                                </h2>
                                <h4>
                                    Charlieference.com will surpass or match any
                                    quote on your group travel needs when reserving
                                    10rooms per night or more at any hotel of equal
                                    or unique facilities <span>more..</span> 
                                </h4>
                            </div>
                            <div className="icon_groups">

                                <div className="groupIcon">
                                    <div className="icon_img">
                                        <img src="assets/buildingpent.png" alt="building" />
                                    </div>
                                    <p>100,000 group-friendly hotels worldwide</p>

                                </div>
                                <div className="groupIcon">
                                    <div className="icon_img">
                                        <img src="assets/handshakepent.png" alt="partner" />
                                    </div>
                                    <p>Free rooms for group cordinators</p>

                                </div>
                                <div className="groupIcon">
                                    <div className="icon_img">
                                        <img src="assets/globepent.png" alt="globe" />
                                    </div>
                                    <p>CharlieFerence is one of the largest seller of group hotel
                                        rooms in the US
                                    </p>

                                </div>
                               
                            </div>
                        </div>
                        <img src="assets/city center.jpg" alt="frankfurt" />
                    </div>
                </div>
                <div className="social_proofs">
                    <div className="cta">
                        <h2>BOOK AS A GROUP. PAY SEPERATELY</h2>
                        <p>Free rooms for group coordinators and lowest group rates guaranteed</p>
                       <div className="group_rate">
                       <Link to="/hoteldeals">Get a group rate</Link>

                       </div>
                        
                        
                    </div>
                    <div className="proof_container">
                        <div className="proof_img">
                            <img src="assets/newyork200.png" alt="" />
                        </div>
                        <div className="proof_img">
                            <img src="assets/wallstreet200.png" alt="" />
                        </div>
                        <div className="proof_img">
                            <img src="assets/usa200.png" alt="" />
                        </div>
                        <div className="proof_img">
                            <img src="assets/inc200.png" alt="" />
                        </div>
                        <div className="proof_img">
                            <img src="assets/yahoo200.png" alt="" />
                        </div>
                        
                    </div>
                    <div className="headliners_container">
                    <div className="headliners">
                            <span> 
                                <MenuBookIcon />
                                Recent News:</span>
                            <div className="headliner_item">
                            <a  href="https://www.softwaredevbytes.com">
                                Death Toll Rises to 16 in Florida Condo Collapse
                                </a>                    

                            </div>
                            <div className="headliner_item">
                            <a  href="https://www.softwaredevbytes.com">
                                New Results Expected in N.Y.C Mayoral Race AFter Botched Count
                                </a>
                            </div>
                            <div className="headliner_item">
                                <a  href="https://www.softwaredevbytes.com">
                            
                               Bill Cosby Released After An Appeal Court overturned Ruling
                               </a>
                            </div>
                          
                        </div>

                    </div>
                   
                </div>
        </div>
        </div>
    )
}

export default Section
